"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _utils = require("./utils");

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

function _default(Component) {
  var ShareInputDecorator =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(ShareInputDecorator, _React$Component);

    function ShareInputDecorator() {
      var _getPrototypeOf2;

      var _this;

      (0, _classCallCheck2.default)(this, ShareInputDecorator);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ShareInputDecorator)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this._defaultInputRef = {
        current: null
      };
      _this.focus = _this.focus.bind((0, _assertThisInitialized2.default)(_this));
      _this.select = _this.select.bind((0, _assertThisInitialized2.default)(_this));
      _this.refCallback = _this.refCallback.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(ShareInputDecorator, [{
      key: "focus",
      value: function focus() {
        if (this._ref && typeof this._ref.focus === 'function') {
          this._ref.focus();

          return;
        }

        var inputRef = this.props.inputRef || this._defaultInputRef;

        if (inputRef.current && typeof inputRef.current.focus === 'function') {
          inputRef.current.focus();
        }
      }
    }, {
      key: "select",
      value: function select() {
        if (this._ref && typeof this._ref.select === 'function') {
          this._ref.select();

          return;
        }

        var inputRef = this.props.inputRef || this._defaultInputRef;

        if (inputRef.current && typeof inputRef.current.select === 'function') {
          inputRef.current.select();
        }
      }
    }, {
      key: "refCallback",
      value: function refCallback(ref) {
        if ((0, _utils.isFunctionalComponent)(Component)) return;
        this._ref = ref;
        if (ref) (0, _utils.copyMethods)(ref, this);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            inputRef = _this$props.inputRef,
            rest = (0, _objectWithoutProperties2.default)(_this$props, ["inputRef"]);
        return _react.default.createElement(Component, (0, _extends2.default)({}, rest, {
          inputRef: inputRef || this._defaultInputRef,
          ref: this.refCallback
        }));
      }
    }]);
    return ShareInputDecorator;
  }(_react.default.Component);

  var componentName = (0, _getComponentName.default)(Component);
  ShareInputDecorator.displayName = "ShareInput(" + componentName + ")";
  ShareInputDecorator.propTypes = (0, _extends2.default)({}, Component.propTypes, {
    inputRef: _refObject.default
  });
  ShareInputDecorator.defaultProps = Component.defaultProps;
  (0, _utils.attachWrappedComponent)(ShareInputDecorator, Component);
  return ShareInputDecorator;
}

module.exports = exports.default;